// extracted by mini-css-extract-plugin
export var cartContainer = "_ig-4";
export var gray = "_ig-1";
export var itemContainer = "_ig-2";
export var itemDetails = "_ig-3";
export var strong = "_ig-0";